// @module Tekyard.PDPSerialLotFunctionality.SerialLotData
define('C3.PDPSerialLotFunctionality.SerialLotData.Carousel.ItemsList'
,	[
	'tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemslist.tpl'
    ,   'C3.PDPSerialLotFunctionality.SerialLotData.Carousel.ItemsCell'
    ,    'tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemscell.tpl'
	,	'Backbone'
	,   'item_relations_cell.tpl'
	,   'item_relations_row.tpl'
	,   'Backbone.CollectionView'
	,   'Utils'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.PDView'
	,   'C3.Utils.CartUtils'
	,   'C3.ClearItems.View'
	,   'CarouselResponsiveUtils'
    ]
, function (
	tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemslist_tpl
	,   SerialCarouselItemsCellView
	,   tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemscell_tpl
	,	Backbone
	,   item_relations_cell_tpl
	,   item_relations_row_tpl
	,   BackboneCollectionView
	,   Utils
	,   SerialLotPDView
	,   CartUtils
	,   ClearItemsView
	,  CarouselResponsiveUtils
)
{
    'use strict';

	// @class C3.PDPSerialLotFunctionality.SerialLotData.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemslist_tpl

	,	initialize: function (options) {	
			this.options = options;	
			this.item = options.item;
			this.origin = options.origin;
			this.application = options.application;
			this.functional = options.functional;
			this.cosmetic = options.cosmetic;
			this.functionalname = options.functionalname;
			this.cosmeticname = options.cosmeticname;
			this.layout = options.layout;
			this.inventoryRecordsList = this.model.get('inventoryrecords');
			//console.log(this.inventoryRecordsList)
			
			this.itemExistsInCart = false;
			this.checkItem(this);
			this.on('afterCompositeViewRender', this.initSlider, this);

			this.on('serial:added serial:removed', this.onSerialChanged, this);
		}

	, onSerialChanged: function (data) {

	    this.checkItem(this);
	    this.once('afterCompositeViewRender', function () {
		    var $container = this.$el.find('.item-relations-row');

		    // clear any previous selection
		    $container.find('.carousel-item.viewing-item').removeClass('viewing-item');

		    // add to the new matching one
		    var $matchingLis = $container.find('li[data-asset="' + data.current + '"]');
		    $matchingLis.find('.carousel-item').addClass('viewing-item');

		    //console.log($matchingLis);
		});

	}

	
	,   initSlider: function initSlider() {
		    var self = this;
		    const carousel = self.$el.find('[data-type="carousel-items"]');

		    const { siteSettings, imageSizeMapping, bxSliderDefaults } = self.options.application.getConfig();

		    if (jQuery(window).width() >= 760 && siteSettings.imagesizes) {
		        const img_min_height = (_.where(siteSettings.imagesizes, {
		            name: imageSizeMapping.thumbnail
		        })[0]).maxheight;

		        carousel
		            .find('.item-relations-related-item-thumbnail')
		            .css('minHeight', img_min_height);
		    }


		    var windowWidth = jQuery(window).width();
    		var carouselSettings = CarouselResponsiveUtils.getCarouselSettings(windowWidth);


		     if(Utils.isPhoneDevice())
            {
            	if(self.inventoryRecordsList && self.inventoryRecordsList.length > 1)
	            	bxSliderDefaults.controls = true;
	            else
	            	bxSliderDefaults.controls = false;
            }
            else{
	            if(self.inventoryRecordsList && self.inventoryRecordsList.length > 3)
	            	bxSliderDefaults.controls = true;
	            else
	            	bxSliderDefaults.controls = false;
            }


		    bxSliderDefaults.slideWidth = 240;
		    bxSliderDefaults.maxSlides = 4;

		    /*bxSliderDefaults.slideWidth = carouselSettings.slideWidth;
            bxSliderDefaults.maxSlides = carouselSettings.maxSlides;*/

		    bxSliderDefaults.hideControlOnEnd = true;
		    bxSliderDefaults.prevText = '<a data-click="left-click" data-action="home-carousel-click" class="home-carousel carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/TekyardWebsite/Tekyard/img/Left Arrow.svg"></a>';
		    bxSliderDefaults.nextText = '<a data-click="right-click" data-action="home-carousel-click" class="home-carousel carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/TekyardWebsite/Tekyard/img/Right Arrow.svg"></a>';

		    bxSliderDefaults.infiniteLoop = false;
		    //console.log(bxSliderDefaults)
		    // --- Preserve slide index ---
		    let savedIndex = 0;
		    if (this.bxSliderInstance) {
		        savedIndex = this.bxSliderInstance.getCurrentSlide();
		        this.bxSliderInstance.destroySlider(); // cleanup old instance
		    }

		    // --- Re-init ---
		    this.bxSliderInstance = Utils.initBxSlider(carousel, bxSliderDefaults);

		    // --- Restore position ---
		    if (this.bxSliderInstance && savedIndex > 0) {
		        this.bxSliderInstance.goToSlide(savedIndex);
		    }

		    // Other stuff (cart UI updates)
		    var inCartAssetTags = this.inCartAssetTags;
		    var elmt = $('[data-view="Clear.Items.List"]');
		    var ClearItems = new ClearItemsView({
		        assets: inCartAssetTags,
		        parentView: this,
		        itemId: this.origin === 'plp' ? this.item.get('internalid') : this.item.internalid,
		        application: this.application
		    });
		    ClearItems.render();
		    elmt.empty().append(ClearItems.$el);

		    var targetParent = $('.seriallot-popup-header'),
		        targetEle = targetParent.find('.serial-cart-items-qty'),
		        inCartItems = this.inCartAssetTags || [];
		    if (targetEle)
		        targetEle.text(inCartItems.length);

		    // Pluralize the noun: 1 -> "Number", 0 or >1 -> "Numbers"
		    var nounLabel = targetParent.find('.serial-noun-label');
		    if (nounLabel && nounLabel.length)
		        nounLabel.text(inCartItems.length === 1 ? 'Number' : 'Numbers');

		    if (!this.hasInitialized) {
			    const self = this;
			    let attempts = 0;

			    function trySelectFirst() {
			        attempts++;
			        const $carousel = self.$el.find('.item-relations-row');
			        const $firstTrigger = $carousel.find('li [data-action="show-product-detail"]').first();

			        if ($firstTrigger.length) {
			            $firstTrigger.trigger('click');
			            //console.log('Auto-selected first after', attempts, 'attempt(s)');
			            self.hasInitialized = true;
			        } else if (attempts < 20) {
			            setTimeout(trySelectFirst, 50); // retry up to 1 second total
			        } else {
			            //console.warn('Auto-select first: no trigger found after 1s, giving up.');
			            self.hasInitialized = true; // mark as initialized to avoid infinite loop
			        }
			    }

			    trySelectFirst();
			}


	}
		

    ,   checkItem: async function checkItem(self) {
    		var self = this;
    		var itemId = self.origin === 'plp' ? self.item.get('internalid') : self.item.internalid;

    		var results = await CartUtils.batchCheckItemsInCart(
    		    self.application,
    		    itemId,
    		    self.inventoryRecordsList
    		);
    		//console.log(results)
		    /*this.updatedInventoryRecordsList = results;*/
		   	this.updatedInventoryRecordsList = results.inventoryRecords;

		    /*this.inCartAssetTags = results
	        .filter(item => item.inCart)
	        .map(item => item.assettag);*/
	        this.inCartAssetTags = results.cartAssets;

		    this.render();
		}

	,	events: {
		  'click [data-action="remove-from-cart"]': 'removeFromCart',
		  'click [data-action="show-product-detail"]': 'showProductDetail'
		}
	

	,   removeFromCart: function removeFromCart(e)
		{
			
			var targetElement = $(e.currentTarget)
			,   assetid = targetElement.attr('data-asset')
			,   itemId = this.origin === 'plp' ? this.item.get('internalid') : this.item.internalid

			var self = this;
			var removed = CartUtils.removeItemFromCart(
		        self.application,
		        itemId,
		        { custcol_internalassettag: assetid }
		    ).then(function(removed) {
			    if (removed) {
			        this.checkItem();
			        this.once('afterCompositeViewRender', function () {
			        	var $container = self.$el.find('.item-relations-row');
			        	var $matchingLis = $container.find('li[data-asset="' + assetid + '"]');
	            	 	$matchingLis.find('.carousel-item').addClass('viewing-item');
			        	this.detailView.refreshCartStatus()
			        });			  
			    }
			}.bind(this));

		}

	,   showProductDetail: function showProductDetail(e)
		{
			
			var targetElement = $(e.currentTarget)
			,   dataAsset = targetElement.attr('data-asset')
			,   dataLocation = targetElement.attr('data-location')
			,   dataInvtImg = targetElement.attr('data-invtimg')
			,   datathumbnail = targetElement.attr('data-thumbnail')
			,   dataLocationId = targetElement.attr('data-locationid')
			,   dataNotes = targetElement.attr('data-notes')
			,   data360 = targetElement.attr('data-360')
			,   dataSalePrice = targetElement.attr('data-saleprice')
			,   clickedParent = targetElement.closest('.carousel-item');
			this.$('li > .carousel-item.viewing-item').removeClass('viewing-item');
			clickedParent.addClass('viewing-item');
			//console.log(dataInvtImg)

			var recList = this.updatedInventoryRecordsList;

			var foundItem = _.findWhere(recList, { assettag: dataAsset }) || [];


			var elmt = $('[data-view="SerialLot.Popup.PD"]')
			var PDView = new SerialLotPDView({
                inventoryid: dataAsset,
                application : this.application,
                item : this.item,
                saleprice : dataSalePrice,
                notes : dataNotes,
                cosmeticname: this.cosmeticname,
                functionalname: this.functionalname,
                location : dataLocation,
                locationid : dataLocationId,
                parentView: this,
                video360: data360,
                invtimg : datathumbnail,
                AINinternalid : dataInvtImg,
                origin : this.origin,
                selectSerial: foundItem
            });
            this.detailView = PDView;
            PDView.render();
            elmt.empty().append(PDView.$el);

		}		

	,	bindings: {
		}

	, 	childViews: {
		}
	

		//@method getContext @return Tekyard.PDPSerialLotFunctionality.SerialLotData.View.Context
	,	getContext: function getContext()
		{
			//console.log(this.updatedInventoryRecordsList)
			return {
				inventoryItemsList : this.updatedInventoryRecordsList
			};
		}
	});
});
